import { Box, CircularProgress } from '@mui/material';

import { COLORS } from './constants';

interface ScoreProcessingBannerProps {
  minHeight?: number | string;
  message?: string;
  footer?: string;
}

export const ScoreProcessingBanner = ({
  minHeight = 300,
  message = 'Calculating your score…',
  footer = 'Your score will appear here shortly.',
}: ScoreProcessingBannerProps) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight,
      gap: 2,
      px: 3,
    }}>
    <span style={{ fontSize: 17, fontWeight: 600, color: COLORS.text }}>Processing</span>
    <CircularProgress size={36} thickness={3} sx={{ color: '#C0FF02' }} />
    <span style={{ fontSize: 14, color: 'var(--tx-muted)', textAlign: 'center' }}>{message}</span>
    <span style={{ fontSize: 12, color: '#666', textAlign: 'center' }}>{footer}</span>
  </Box>
);
